import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackPixelEvent } from '../hooks/useMetaPixel';
import { brand, offer } from '../data/content';
interface CtaButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  size?: 'md' | 'lg' | 'xl';
  href?: string;
  className?: string;
}
export function CtaButton({
  children,
  variant = 'primary',
  size = 'lg',
  href = '#planes',
  className = ''
}: CtaButtonProps) {
  const base = 'group inline-flex items-center justify-center gap-3 rounded-2xl text-center font-extrabold uppercase leading-tight tracking-tight transition-[transform,background-color,box-shadow,color] duration-150 ease-out focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-blue-300 active:translate-y-px';
  const sizes = {
    md: 'px-6 py-3.5 text-sm',
    lg: 'px-5 py-4 text-base md:px-8 md:text-lg',
    xl: 'px-5 py-5 text-lg md:px-8 md:text-2xl'
  };
  const variants = {
    primary: 'bg-blue-600 text-white shadow-lg hover:bg-blue-700',
    secondary: 'bg-white text-blue-700 ring-2 ring-inset ring-blue-200 hover:bg-blue-50'
  };
  const isCheckout = href.startsWith('http');
  const handleClick = () => {
    if (isCheckout) {
      trackPixelEvent('InitiateCheckout', {
        content_name: brand.name,
        value: Number(offer.price),
        currency: offer.currencyCode
      });
    }
  };
  return <a href={href} onClick={handleClick} className={`${base} ${sizes[size]} ${variants[variant]} ${className}`} data-id="element-54" data-mp="3owju46sl6ixq">
      <span data-id="element-55" data-mp="3swap6mp5bl82">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1 md:h-6 md:w-6" aria-hidden="true" data-id="element-56" data-mp="3sviynqaeodon" />
    </a>;
}